import api from "./Api";

class IntegracaoAmazonService {
  GetAuthorizationUrl() {
    return api
      .get("/v1/integracoes/amazon/authorization-url")
      .then((response) => response.data);
  }

  RefreshToken() {
    return api
      .post("/v1/integracoes/amazon/refresh-token")
      .then((response) => response.data);
  }

  Disconnect() {
    return api
      .post("/v1/integracoes/amazon/disconnect")
      .then((response) => response.data);
  }

  UpdateNfeAutomatica(enabled) {
    return api
      .post("/v1/integracoes/amazon/nfe-automatica", null, {
        params: { enabled },
      })
      .then((response) => response.data);
  }

  ExportProducts(payload) {
    return api
      .post("/v1/integracoes/amazon/produtos/exportar", payload)
      .then((response) => response.data);
  }

  ImportProducts() {
    return api
      .post("/v1/integracoes/amazon/produtos/importar")
      .then((response) => response.data);
  }
}

export default new IntegracaoAmazonService();
